const getTextWidth = (node, letterWidth) => {
  const words = node.data.id.split(' ');
  const wordLengths = words.map(t => t.length);
  const longestWordLength = Math.max(...wordLengths);

  return longestWordLength * letterWidth;
};

export default getTextWidth;
